<template>
	<div>
		<div class="banner" v-if="info">
			<img :src="info.station_img" />
		</div>
		<div class="washInfo" v-if="info">
			<div class="title">{{ info.station_name }}</div>
			<div class="date">营业时间: {{ info.wash_time }}</div>
			<div class="add">
				<div class="addInfo">
					<img src="images/car_wash/add.png" />
					<span>{{ info.station_address }}</span>
				</div>
                <a :href="`http://api.map.baidu.com/marker?location=${wd},${jd}&title=${info.station_name}&content=${info.station_name}&output=html`" class="link">
                    <div class="navigationBtn">
                        <img src="images/car_wash/fly.png" alt />
                        <span>导航</span>
                    </div>
                </a>
			</div>
		</div>
		<div class="waitMain" v-if="info">
<!--			<div class="options">-->
<!--				<span class="key">当前叫号</span>-->
<!--				<span class="val">{{ info.id }}</span>-->
<!--			</div>-->
			<div class="options">
				<span class="key">等待人数</span>
				<span class="val">{{ info.count }}</span>
			</div>
			<div class="options">
				<span class="key">预计等待时间</span>
				<span class="val">{{info.count * 5}}分钟</span>
			</div>
			<input type="button" value="预约洗车" @click="showPopup" />
		</div>
	</div>
</template>

<script>
import { washStatfo } from '@/apis/car_wash'

export default {
  data() {
    return {
      info: null,
      jd:'',
      wd:''
    }
  },
  created() {
    if (this.$route.query.id) {
      washStatfo(this.$route.query.id).then(res => {
        console.log(res)
        this.info = res.data
        let jw = this.info.location.split(',')
        this.jd = jw[0]
        this.wd = jw[1]
        console.log(jw)
      })
    }
  },
  mounted() {},
	methods: {
    showPopup() {
      this.$router.push({
        name: "make_time",
        query: {
          id: this.$route.query.id,
          washTime: this.info.wash_time
        }
      });
    }
  }
}
</script>

<style scoped>
.banner {
	height: 53.333vw;
}

.banner > img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.washInfo {
	width: 92vw;
	padding: 6.667vw 0 5.333vw;
	border-bottom: 1px dashed #edeff2;
	margin: 0 auto;
}

.title {
	font-size: 5.333vw;
	color: #303133;
	font-weight: bold;
}

.date {
	font-size: 3.467vw;
	color: #909399;
	margin-top: 2.4vw;
}

.add {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-top: 2.93vw;
}

.addInfo {
	display: flex;
	align-items: center;
}

.addInfo img {
	width: 2.933vw;
	height: 3.733vw;
	margin-right: 1.067vw;
}

.addInfo span {
	width: 60vw;
	display: block;
	font-size: 3.467vw;
	color: #606266;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.link {
    display: block;
	color: #606266;
}

.navigationBtn {
	width: 18.933vw;
	height: 8.533vw;
	border-radius: 4.267vw;
	border: solid 0.133vw #303133;
	display: flex;
	align-items: center;
	justify-content: center;
}

.navigationBtn img {
	width: 3.2vw;
	height: 3.2vw;
	margin-right: 1.467vw;
}

.waitMain {
	width: 92vw;
	margin: 0 auto;
	padding: 1.4vw 0 14vw;
}

.waitMain .options {
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-size: 4.267vw;
	margin-top: 5.2vw;
}

.waitMain .options .key {
	color: #606266;
}

.waitMain .options .val {
	color: #303133;
}

input[type='button'] {
	width: 92vw;
	height: 12.533vw;
	background-color: #096c47;
	border-radius: 2.667vw;
	color: #fefefe;
	font-size: 4.8vw;
	border: none;
	outline: none;
	margin-top: 17.2vw;
}

</style>
